class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    if (facetForm.classList.contains('facets-sort')) {
      facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    }
    if (this.querySelector('.facets__form-drawer-selected')) {
      const filterSelected = this.querySelector('.facets__form-drawer-selected');

      const itemsFilterSelected = filterSelected.querySelectorAll('facet-remove');
      const numberSelected = document.querySelector('#number_selected');      
      if (numberSelected && itemsFilterSelected.length > 1) {
        numberSelected.textContent = `(${itemsFilterSelected.length - 1})`;
      }
    }

    const applyFilterButton = this.querySelector('.mobile-facets__footer #apply_filter');
    if (applyFilterButton) {
      const applyFiltersAndClose = (event) => {
        event.preventDefault();

        const checkedInputs = this.querySelectorAll('.collection-filters-wrapper .list-menu__item input:checked');
        checkedInputs.forEach((input) => {
          const inputValue = input.value;

          const selectElement = this.querySelector('.custom-select .select__select');
          const matchingOption = selectElement.querySelector(`option[value="${inputValue}"]`);

          if (matchingOption) {
            selectElement.value = matchingOption.value;
            selectElement.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
          }
        });

        const searchParams = this.createSearchParams(facetForm);
        this.onSubmitForm(searchParams, event);
      };

      applyFilterButton.addEventListener('click', applyFiltersAndClose);

      // Add click handler to clear button to close drawer
      const clearButton = this.querySelector('.mobile-facets__footer .mobile-facets__clear');
      if (clearButton) {
        clearButton.addEventListener('click', () => {
          // Let the default clear action happen, then close the drawer
          setTimeout(() => {
            const mobileDrawer = this.closest('menu-drawer');
            if (mobileDrawer) {
              const drawerDetails = mobileDrawer.querySelector('details');
              if (drawerDetails && drawerDetails.hasAttribute('open')) {
                const summary = drawerDetails.querySelector('summary');
                if (summary) {
                  summary.click();
                }
              }
            }
          }, 100);
        });
      }

      // Add click handler to background overlay
      const mobileDrawer = this.closest('menu-drawer');
      if (mobileDrawer) {
        const mobileForm = this.querySelector('#FacetFiltersFormMobile');
        if (mobileForm) {
          mobileForm.addEventListener('click', (event) => {
            // Check if click is directly on the form background (not on inner content)
            if (event.target === mobileForm || event.target.classList.contains('mobile-facets')) {
              const drawerDetails = mobileDrawer.querySelector('details');
              if (drawerDetails && drawerDetails.hasAttribute('open')) {
                const summary = drawerDetails.querySelector('summary');
                if (summary) {
                  summary.click();
                }
              }
            }
          });
        }
      }
    }
    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const dataMinPrice = form.querySelector('input[name="filter.v.price.gte"]')?.getAttribute('min') || null
    const dataMaxPrice = form.querySelector('input[name="filter.v.price.lte"]')?.getAttribute('max') || null
    const formData = new FormData(form);

    if(parseInt(dataMinPrice) === parseInt(formData.get('filter.v.price.gte')) && parseInt(dataMaxPrice) === parseInt(formData.get('filter.v.price.lte'))) {
      formData.delete('filter.v.price.gte')
      formData.delete('filter.v.price.lte')
    }

    console.log(new URLSearchParams(formData).toString());
    
    
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

// class FacetSort extends HTMLElement {
//   constructor() {
//     super();
//     this.querySelectorAll('.facets__sort-option').forEach((element) => {  
//       element.addEventListener('click', this.onSortChange.bind(this));    
//     });
//   }

//   onSortChange(event) {

//     const select = this.querySelector('.custom-select select[name="sort_by"]');
    
//     if (select) {
//       this.querySelectorAll('.facets__sort-option').forEach((element) => {
//         element.classList.remove('selected');
//       });
//       event.currentTarget.classList.add('selected');
//       select.value = event.currentTarget.dataset.value;
//       console.log(select.value);
//       select.dispatchEvent(new Event('change', {
//         bubbles: true,
//         cancelable: true
//       }));
//     } else {
//       console.error('Không tìm thấy phần tử select');
//     }
//   }
// }
// customElements.define('facet-sort', FacetSort);
class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('price-range input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange() {
    this.setMinAndMaxValues();
    this.ajaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('price-range input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) maxInput.setAttribute('value', maxInput.value);
    if (minInput.value) minInput.setAttribute('value', minInput.value);
    if (minInput.value === '') minInput.setAttribute('value', 0);
    if (maxInput.value === '') maxInput.setAttribute('value', maxInput.getAttribute('value'));
  }
  ajaxValues() {
    const inputfrom = document.getElementById('filter-from');
    const inputto = document.getElementById('filter-to');
    const min = Number(inputfrom.getAttribute('value'));
    const max = Number(inputto.getAttribute('value'));
    const maxdefault = Number(inputto.getAttribute('max'));
    const subtotal = max - min;
    const total = (subtotal / maxdefault ) * 100; 
    const left = (min / maxdefault) * 100;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

const observerSelected = new MutationObserver(() => {
  if (document.querySelector('.facets__form-drawer-selected')) {
    const filterSelected = document.querySelector('.facets__form-drawer-selected');

    const itemsFilterSelected = filterSelected.querySelectorAll('facet-remove');
    const numberSelected = document.querySelector('#number_selected');      
    if (numberSelected && itemsFilterSelected.length > 1) {
      numberSelected.textContent = `(${itemsFilterSelected.length - 1})`;
    }
  }
});

observerSelected.observe(document.querySelector('.active-facets-desktop'), {
  childList: true,
});

